module.exports = __webpack_public_path__ + "static/media/photo21.e3b96b86.jpg";